export const IS_USER_MANAGEMENT_LOADER = 'IS_USER_MANAGEMENT_LOADER';
export const IS_API_LOADER = 'IS_API_LOADER';

export const userManagementApiLoader = ({isUsermanagementLoader}) => {
    return {
    type: IS_USER_MANAGEMENT_LOADER,
    payload: {isUsermanagementLoader}
}};

export const userApiLoader = ({isApiLoader}) => ({
    type: IS_API_LOADER,
    payload: {isApiLoader}
});